<template>
  <div class="left-anchor">
    <ul class="anchor-inbox">
      <template v-for="(activity, index) in activityArr">
        <li
          :key="index"
          :class="{ active: activeItem === activity.id }"
          @click="jumpToAnchor(activity.id)"
        >
          {{ activity.label }}
        </li>
      </template>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    activities: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      activeItem: ''
    }
  },
  computed: {
    activityArr() {
      const arr = Object.values(this.activities) || []
      return arr.filter(value => !value.hide)
    }
  },
  watch: {
    activityArr: {
      handler: function(val) {
        if (val.length) {
          this.activeItem = val[0]?.id
        }
      },
      immediate: true
    }
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('scroll', this.onScroll, true)
    })
  },

  destroyed() {
    // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
    window.removeEventListener('scroll', this.onScroll, true)
  },

  methods: {
    /**
     * 跳转到相应的锚点
     */
    jumpToAnchor(id) {
      this.activeItem = id
      document.getElementById(id).scrollIntoView({
        behavior: 'smooth'
      })
    },

    /**
     * 滚动监听元素
     */
    onScroll() {
      // 获取所有锚点元素
      const navContents = document.querySelectorAll('.detail-anchor-card a')
      // 所有锚点元素的 offsetTop
      const offsetTopArr = []
      navContents.forEach(item => {
        offsetTopArr.push(item.offsetTop)
      })
      // 获取当前文档流的 scrollTop
      const scrollTop =
        document.getElementById('rightContainer').scrollTop ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset

      // 定义当前点亮的导航下标
      let navIndex = 0
      for (let n = 0; n < offsetTopArr.length; n++) {
        // 如果 scrollTop 大于等于第 n 个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
        // 那么此时导航索引就应该是 n 了
        if (scrollTop >= offsetTopArr[n]) {
          navIndex = n
        }
      }
      // 把下标赋值给 vue 的 data
      this.activeItem = this.activityArr[navIndex].id || ''
    }
  }
}
</script>
<style lang="scss" scoped>
$bg-color: #e8f4ff;
.left-anchor {
  width: 194px;
  height: 100%;
  position: absolute;
  border-right: 2px solid $body-background-color;
}
.anchor-inbox {
  padding-top: 16px;
  width: 160px;
  margin: 0 auto;
  margin-block-start: 0em;
  margin-block-end: 0em;
  padding-inline-start: 0px;
  z-index: 100;
  li {
    cursor: pointer;
    display: block;
    font-size: 14px;
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-weight: normal;
    border-radius: 4px;
    padding-left: 24px;
    & + li {
      margin-top: 8px;
    }
    &:hover {
      color: $primary-color;
      // background-color: $bg-color;
    }
    &.active {
      color: $primary-color;
      background-color: $bg-color;
    }
  }
}
</style>
